import {
  NEW_STATUS,
  PENDING_STATUS,
  INCOMPLETE_STATUS,
  EXCEPTION_STATUS,
  EDIT_STATUS,
  APPROVED_STATUS,
  DELETED_STATUS,
  AUTO_APPROVED_STATUS,
  AUTO_COMPLETE_STATUS,
} from "config";
import moment from "moment";
import { EMPTY } from "pages/AddWorker/config";
import I18n from "i18n";
import { login } from "pages/Punch/constants";

export const getActivity = (
  activityGroup,
  name,
  startDate,
  endDate,
  isActive,
  managerFirstName,
  managerLastName,
  managerId,
  managerEmail,
  country,
  actionBy,
  actionType,
  actionTS,
  isJobRoleRestricted,
  selectedJobFamilies,
  isDistrictRestricted,
  restrictedDistricts
) => {
  if (moment(startDate).isValid()) {
    startDate = startDate.toISOString();
  } else {
    startDate = null;
  }

  if (moment(endDate).isValid()) {
    endDate = endDate.toISOString();
  } else {
    endDate = null;
  }
  
  if(name) name = name.trim();

  const activity = {
    activityGroup,
    name,
    startTS: startDate,
    endTS: endDate,
    isActive,
    managerFirstName,
    managerLastName,
    managerId,
    managerEmail,
    country,
    actionBy,
    actionType,
    actionTS,
    isJobRoleRestricted,
    jobRoles: selectedJobFamilies,
    isDistrictRestricted,
    restrictedDistricts
  };

  // console.log("ACTIVITY : ", activity);

  return activity;
};

export const udpatePunchStatus = (punches) => {
  if (typeof punches === "object" && punches.length > 0) {
    punches.map((doc, ind) => {
      if(doc.status == NEW_STATUS || doc.status == EDIT_STATUS) doc.status = NEW_STATUS;
      if(!doc.outLocalTS) doc.status = INCOMPLETE_STATUS;
      let hours = 0;
      doc.editable=true;
      const startDate = moment().subtract(2, 'weeks').startOf('week').format("YYYY-MM-DD");
        const endDate = moment().add(2, 'weeks').startOf('week').format("YYYY-MM-DD");
        if (
          doc.inLocalTS &&
          doc.inLocalTS !== "" 
        ){
          
          let punchInRecordDate = moment(doc.inLocalTS).format("YYYY-MM-DD");

          if(doc.nonEditable && doc.nonEditable === true){
            doc.editable=false;
          }
          if (moment(punchInRecordDate).isBefore(startDate) || moment(punchInRecordDate).isAfter(endDate)) 
          {
            doc.editable=false;
          }
          
        }

      
      if (
        doc.inLocalTS &&
        doc.inLocalTS !== "" &&
        doc.outLocalTS &&
        doc.outLocalTS !== ""
      ) {
        const end = moment(doc.outLocalTS && doc.outLocalTS.substr(0, 16));
        const start = moment(doc.inLocalTS && doc.inLocalTS.substr(0, 16));
        const diff = moment.duration(end.diff(start));
        let punchInRecordDate = moment(doc.inLocalTS).format("YYYY-MM-DD");
       
        if(doc.nonEditable && doc.nonEditable === true){
          doc.editable=false;
        }else{
          if (moment(punchInRecordDate).isBetween(startDate,endDate) || moment(punchInRecordDate).isSame(startDate) || moment(punchInRecordDate).isSame(endDate)) 
          { 
            doc.editable=true;
          }else  doc.editable=false;
        }
        
        hours = diff.asHours();
      }
      hours = hours.toFixed(2);
      if(hours >24 && doc.status!==DELETED_STATUS) doc.status=EXCEPTION_STATUS;

      switch (doc.status) {
        case DELETED_STATUS:
          doc.color = login.outColor;
          doc.statusTranslated = I18n.t("other.lblDeleted");
          break;
        case EXCEPTION_STATUS:
          doc.color = login.clockOutColor;
          doc.statusTranslated = I18n.t("other.lblException");
          break;
        case INCOMPLETE_STATUS:
          doc.color = login.outColor;
          doc.statusTranslated = I18n.t("other.lblIncomplete");
          break;
        case NEW_STATUS:
          doc.color = login.nameColor;
          doc.statusTranslated = I18n.t("other.lblPending");
          doc.status = PENDING_STATUS;
          break;
        case APPROVED_STATUS:
          doc.color = login.clockInColor;
          doc.statusTranslated = I18n.t("other.lblApproved");
          break;
        case AUTO_APPROVED_STATUS:
          doc.color = login.clockInColor;
          doc.statusTranslated = I18n.t("other.lblAutoApproved");
          break;
        case AUTO_COMPLETE_STATUS:
          doc.color = login.clockOutColor;
          doc.statusTranslated = I18n.t("other.lblAutoComplete");
          break;
        default:
          doc.color = login.dateColor;
      }
    });
  }
  return punches;
};

export const udpateHighDurationPunchStatus = (punches) => {
  console.log("utils > udpateHighDurationPunchStatus called...");
  let updatedPunches = [];
  let sortedPunches = [];
  let workerPunchesMap = new Map();
  if (typeof punches === "object" && punches.length > 0) {
    
    punches.map((doc, ind) => {
      let hours = 0;
      if (
        doc.inLocalTS &&
        doc.inLocalTS !== "" &&
        doc.outLocalTS &&
        doc.outLocalTS !== ""
      ) {
        const end = moment(doc.outLocalTS && doc.outLocalTS.substr(0, 16));
        const start = moment(doc.inLocalTS && doc.inLocalTS.substr(0, 16));
        const diff = moment.duration(end.diff(start));
        hours = diff.asHours();
      }
      hours = hours.toFixed(2);
      if(hours > 12 && doc.status!==DELETED_STATUS){

        if(hours >24) {
          doc.color = login.clockOutColor;
          doc.status=EXCEPTION_STATUS;
          doc.statusTranslated = I18n.t("other.lblException");
        }
        else if(hours <=24){
          doc.color = login.nameColor;
          doc.statusTranslated = I18n.t("other.lblPending");
          doc.status = PENDING_STATUS;
        }
        
        doc.diffHrs=hours;
        updatedPunches.push(doc);
      } 
      
    });
    //workerPunchesMap=workerPunchesMap.sort((a,b)=>b.diff.localeCompare(a.diff));

    updatedPunches=updatedPunches.sort((a,b)=>b.diffHrs.localeCompare(a.diffHrs));
  //  let  testMap = new Map([...workerPunchesMap].sort((a, b) => String(b[0]).localeCompare(a[0])))
     
  //     for (let actGrp of testMap.keys()) {
  //       const actGrpHours = testMap.get(actGrp)
  //       sortedPunches.push(actGrpHours);
  //     }

    

  }
  return updatedPunches;
};
